import React from 'react';
import { Box, Modal, ModalBody, ModalContent, ModalOverlay, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useReduxDispatch } from '../../app/store';
import { ArcButton } from '../../common/components/ArcButton';
import { IS_RUNNING_TESTS } from '../../common/constants';
import { markWelcomeModalSeen, selectHasSeenWelcomeModal } from './rebrandingSlice';

export function SEMonitorWelcomeModal() {
  const { t } = useTranslation();
  const dispatch = useReduxDispatch();
  const hasSeenWelcomeModal = useSelector(selectHasSeenWelcomeModal);
  const bgColor = useColorModeValue('#ffffff', '#111111');

  // Don't show modal during tests (Cypress, Jest, Appium, etc.)
  if (IS_RUNNING_TESTS) {
    return null;
  }

  const handleClose = () => {
    dispatch(markWelcomeModalSeen());
  };

  return (
    <Modal isCentered onClose={handleClose} isOpen={!hasSeenWelcomeModal} motionPreset="slideInBottom">
      <ModalOverlay />
      <ModalContent mx={4} maxW="sm" bg={bgColor}>
        <ModalBody px={6} py={8}>
          <VStack spacing={6} align="stretch" textAlign="center">
            <Text
              fontSize="2xl"
              fontWeight="bold"
              color="customGrey.900"
              _dark={{ color: 'white' }}
              data-testid="se-monitor-welcome-title"
            >
              {t('SEMonitor Welcome.title')}
            </Text>

            <Box>
              <Text
                fontSize="md"
                lineHeight="1.6"
                color="customGrey.800"
                _dark={{ color: 'customGrey.400' }}
                data-testid="se-monitor-welcome-description"
              >
                {t('SEMonitor Welcome.description')}
              </Text>
            </Box>

            <ArcButton
              py={6}
              w={'100%'}
              arcColor="#3DCD57"
              onClick={handleClose}
              data-testid="se-monitor-welcome-button"
            >
              {t('Common.get started')}
            </ArcButton>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
